import { render, staticRenderFns } from "./vehicle-player-navigation.vue?vue&type=template&id=bf5622d6&"
import script from "./vehicle-player-navigation.vue?vue&type=script&lang=js&"
export * from "./vehicle-player-navigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports